import "./block-video.scss";

const blockVideo = () => {
    let allBlockVideo = document.querySelectorAll('.im-block-video');
    if(!allBlockVideo.length) return;

    allBlockVideo.forEach(el => {

        let videoToPlay = el.querySelector('video');  
        let videoMedia = el.querySelector('.im-block-video__media');  
        let playButton = el.querySelector('.im-block-video__button-play');
        if(!playButton || !videoToPlay) return;

        playButton.addEventListener('click', () => {
            videoToPlay.play();
            videoToPlay.controls = true;
            playButton.classList.add('hide');
            videoMedia.classList.add('play');
        })

        videoToPlay.onpause = () => {
            playButton.classList.remove('hide');
            videoMedia.classList.remove('play');
            videoToPlay.controls = false;
        }

    });
}

export default blockVideo;